module.exports = __webpack_public_path__ + "static/r30-ea4b7c77118b74a20d46c694a341c538.jpg";